export const REGEX = {
    NO_WHITE_SPACE: /^\S*$/,
    MAIL_BOX: /^[a-zA-Z0-9-]*$/,
    HOST_NAME: /^[a-zA-Z0-9-_]*$/,
    HAS_ALPHANUMERIC: /[A-Za-z0-9]+/,
    EMAIL: /^[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/,
    NOT_NUMBER: /[^\d]/g,
    EXCLUDE_NEGATIVE_NUMBER: /[^0-9]/g,
    ACCOUNT_NUMBER: /[^A-Z0-9]/g,
    NOT_UNICODE: /^[a-zA-Z0-9!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]*$/,
    PASSWORD:
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]{8,}$/,
    VALID_BRAND_NAME: /^[a-zA-Z0-9-_,-. ]*$/,
    STRING_NOT_BLANK: /([^\s])/,
    SERVER_NAME_REGEX: /[^\w.-]/g,
    NUMBER: /[^0-9]/g,
    SUBDOMAIN: /^(?!-)[a-zA-Z0-9-]{1,32}$/,
    VALID_REGISTRATION_NUMBER: /^[A-Za-z0-9 ]*$/,
};

export const REGEX_STRING = {
    DOMAIN: '^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9]\\.[a-zA-Z]{2,}$',
    SUB_DOMAIN:
        '^([a-zA-Z0-9]([-a-zA-Z0-9]{0,61}[a-zA-Z0-9])?\\.)([a-zA-Z0-9]{1,2}([-a-zA-Z0-9]{0,252}[a-zA-Z0-9])?)\\.([a-zA-Z]{2,63})$',
    EMAIL: '^(([^<>()[\\]\\\\.,;:\\s@"]+(\\.[^<>()[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$',
    URL: '(ftp|http|https):\\/\\/(\\w+:{0,1}\\w*@)?(\\S+)(:[0-9]+)?(\\/|\\/([\\w#!:.?+=&%@!\\-\\/]))?',
    NO_WHITE_SPACE: '^\\S*$',
};

export const REGEX_PROFILE = {
    BILLING_ADDRESS: /^[\p{L}\p{M}\p{Cf}\p{N}! "#$%&'()*+,./:;=?@^_~-]+$/u,
    CITY: /^[\p{L}\p{M}\p{Cf}\p{N}! "#$%&'()*+,./:;=?@^_~-]+$/u,
    STATE_PROVINCE: /^[\p{L}\p{M}\p{Cf}\p{N}! "#$%&'()*+,./:;=?@^_~-]+$/u,
    USER_NAME: /^[\p{L}\p{M}\p{Cf} ]+$/u,
};

export const REGEX_WWW = /^www\./;
